var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    x2: 25,
    y1: 7,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    x2: 25,
    y1: 25,
    y2: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCancel);
export default __webpack_public_path__ + "static/media/cross-cancel.43239033dcfbe7327f934b3cf0fad17f.svg";
export { ForwardRef as ReactComponent };